import { Pipe, PipeTransform } from '@angular/core';


/**------------------------------------------------------
 * Return the keys from the Object
 * -------------------------------
 * Usage:
 * 	value (Object) | ngKeys
 * Example:
 * 	{{ marketplaces | ngKeys }}
 * 	returns an array with all the keys from the input object
 */
@Pipe({
    name: 'ngKeys',
    standalone: false
})
export class NgKeysPipe implements PipeTransform {

	transform(value: object): Array<any> {
		return Object.keys(value);
	}
}
